import { useEffect, useState } from "react";
import { useStoreService } from "../../service/store/index";
import { IStore } from "../../utils/interfaces/IStore";

const useGetStoreDetails = (id: string) => {
  const { getStoreById } = useStoreService();
  const [data, setData] = useState<IStore>();
  const [error, setError] = useState<any>();
  const [isLoading, setIsLoading] = useState<Boolean>(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (id) {
          setIsLoading(true);
          const response = await getStoreById(parseInt(id, 10));
          setData(response.data);
        }
      } catch (err) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    data,
    error,
    isLoading,
  };
};

export default useGetStoreDetails;
